import React, { useEffect } from 'react'
import { Container, Title } from './styles'
import { useFetalDiagnoses } from '~/context'
import { useMaternalInfantViewSettings } from '~/hooks'
import { message } from '~/services'
import { capitalize } from '~/utils'
import { IFetalDiagnosis } from '~/interfaces'
import { Tabs } from '~/components/shared'
import { FetalDiagnosesList } from '~/components/fetalDiagnoses/FetalDiagnosesList'

export const FetalDiagnosesContent = (): JSX.Element => {
  const { getFetalDiagnoses, fetalDiagnoses, isLoading, errorMessage } = useFetalDiagnoses()
  const { getMaternalInfantViewSettings } = useMaternalInfantViewSettings()

  useEffect(() => {
    const { selectedPregnancy } = getMaternalInfantViewSettings()
    getFetalDiagnoses({ pathParams: { pregnancyId: selectedPregnancy.pregnancyId } })
  }, [getFetalDiagnoses, getMaternalInfantViewSettings])

  const renderTabOptionItem = (): JSX.Element | JSX.Element[] => {
    if (isLoading || !fetalDiagnoses.length) return <Tabs.Item>{message('fetalDiagnoses.fetus_placeholder')}</Tabs.Item>

    const fetusNames = fetalDiagnoses.reduce<string[]>((acc, currFetus) => {
      const name = `Feto ${currFetus.fetusId}`
      if (acc.includes(name)) return acc

      return [...acc, name]
    }, [])

    return fetusNames.map(name => <Tabs.Item key={name}>{name}</Tabs.Item>)
  }

  const renderTabContent = (): JSX.Element | JSX.Element[] => {
    if (isLoading || errorMessage) return <FetalDiagnosesList diagnoses={[]} />

    const fetusContent = fetalDiagnoses.reduce<IFetalDiagnosis[][]>((acc, currFetus) => {
      const existentFetusDiagnosesById = acc.find(fetus => fetus[0].fetusId === currFetus.fetusId)

      if (existentFetusDiagnosesById) {
        existentFetusDiagnosesById.push(currFetus)
        return acc
      }

      return [...acc, [currFetus]]
    }, [])

    return fetusContent.map((fetusDiagnoses, index) => <FetalDiagnosesList key={index} diagnoses={fetusDiagnoses} />)
  }

  return (
    <Container>
      <Title>{capitalize(message('fetalDiagnoses.fetal_diagnoses'))}</Title>

      <Tabs>
        <Tabs.Options>{renderTabOptionItem()}</Tabs.Options>
        <Tabs.Content display="flex">{renderTabContent()}</Tabs.Content>
      </Tabs>
    </Container>
  )
}
